// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ymMX","controls":"styles_controls__2793L","charLimit":"styles_charLimit__2OFCI","input":"styles_input__3iQm_","send":"styles_send__1oiat"};